import axios from 'axios'

export default{
    Application:{
        async Send(data){
            const response = await axios.post('/api/hgs/isbankasi/send/hgsapplication',data,{headers: { "Content-Type": "multipart/form-data" }})
            return response
        },
        async CreatePDF(data){
            const response = await axios.post('/api/hgs/isbankasi/create/hgsapplicationpdf',data)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/hgs/isbankasi/applicationtable',data)
            return response
        },
        async Get(data){
            const response = await axios.get(`/api/hgs/isbankasi/get/application/${data}`)
            return response
        },
        async DownloadPDF(data){
            const response = await axios.get(`/api/hgs/isbankasi/download/hgsapplicationpdf/${data}`,{
                responseType: 'blob',
            })
            return response
        },
        async DownloadSignedPDF(data){
            const response = await axios.get(`/api/hgs/isbankasi/download/signedhgsapplicationpdf/${data}`,{
                responseType: 'blob',
            })
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/hgs/isbankasi/delete/application/${data}`)
            return response
        }
    },
    Cancel:{
        async Send(data){
            const response = await axios.post('/api/hgs/isbankasi/send/hgscancelapplication',data,{headers: { "Content-Type": "multipart/form-data" }})
            return response
        },
        async Table(data){
            const response = await axios.post('/api/hgs/isbankasi/applicationcanceltable',data)
            return response
        },
        async CreatePDF(data){
            const response = await axios.post('/api/hgs/isbankasi/create/hgscancelapplicationpdf',data)
            return response
        },
        async Get(data){
            const response = await axios.get(`/api/hgs/isbankasi/get/cancelapplication/${data}`)
            return response
        },
        async DownloadPDF(data){
            const response = await axios.get(`/api/hgs/isbankasi/download/hgscancelapplicationpdf/${data}`,{
                responseType: 'blob',
            })
            return response
        },
        async DownloadSignedPDF(data){
            const response = await axios.get(`/api/hgs/isbankasi/download/hgssignedcancelapplicationpdf/${data}`,{
                responseType: 'blob',
            })
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/hgs/isbankasi/delete/cancelapplication/${data}`)
            return response
        }
    },
    async GiseTable(data){
        const response = await axios.post('/api/hgs/hgsgise/table',data)
        return response
    },
    async GiseSetIgnoredStatus(id){
        const response = await axios.post(`/api/hgs/hgsgise/setignoredstatus/${id}`)
        return response
    }
}